/// <amd-module name="NetSuite.LogoList.LogoListCCT.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("NetSuite.LogoList.LogoListCCT.View", ["require", "exports", "CustomContentType.Base.View", "Backbone.CollectionView", "Backbone", "jQuery", "NetSuite.LogoList.Common.Utils", "NetSuite.LogoList.LogoListCCT.Logo.View", "NetSuite.LogoList.Common.Instrumentation.Helper", "NetSuite.LogoListCCT.Utils", "netsuite_logolist_logolistcct.tpl", "jQuery.bxSlider@4.2.14"], function (require, exports, CustomContentTypeBaseView, BackboneCollectionView, Backbone, jQuery, Utils_1, LogoListCCT_Logo_View_1, Instrumentation_Helper_1, LogoListUtils, netsuite_logolist_logolistcct_tpl) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var LogoListCCTView = /** @class */ (function (_super) {
        __extends(LogoListCCTView, _super);
        function LogoListCCTView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = netsuite_logolist_logolistcct_tpl;
            _this.events = {
                'click [data-action="sc-logolist-linkclick"]': 'logLinkClick',
            };
            _this.MAX_LOGO_COUNT = 12;
            _this.WRAPPER_CLASS = 'logolistcct-wrapper';
            _this.GRID_MARGIN_WRAPPER_CLASS = 'logolistcct-grid-margin-wrapper';
            _this.CAROUSEL_CONTROLS_WRAPPER_CLASS = 'logolistcct-carousel-controls-wrapper';
            _this.CAROUSEL_CONTAINER_CLASS = 'logolistcct-carousel-container';
            _this.BXSLIDER_WRAPPER_CLASS = 'logolistcct-bx-wrapper';
            _this.RESIZE_RERENDER_THRESHOLD = 100;
            _this.TEXT_COLOR_CLASS = {
                1: '',
                2: 'logolistcct-text-color-dark',
                3: 'logolistcct-text-color-light',
            };
            _this.preventLinkClickLog = false;
            if (options) {
                _this.container = options.container;
            }
            return _this;
        }
        LogoListCCTView.prototype.install = function (settings, contextData) {
            var _this = this;
            _super.prototype.install.call(this, settings, contextData);
            this.parseSettings();
            this.windowWidth = $(window).width();
            this.on('afterViewRender', function () {
                _this.initSlider();
            });
            this.logInformation();
            return jQuery.Deferred().resolve();
        };
        LogoListCCTView.prototype.update = function (settings) {
            _super.prototype.update.call(this, settings);
            this.parseSettings();
            return jQuery.Deferred().resolve();
        };
        LogoListCCTView.prototype.validateContextDataRequest = function () {
            return true;
        };
        LogoListCCTView.prototype.parseSettings = function () {
            this.logoList = {
                header: LogoListUtils.getSetting(this.settings, 'header', ''),
                cntDesktop: +LogoListUtils.getSetting(this.settings, 'cnt_desktop', '6'),
                cntTablet: +LogoListUtils.getSetting(this.settings, 'cnt_tablet', '3'),
                cntPhone: +LogoListUtils.getSetting(this.settings, 'cnt_phone', '2'),
                style: +LogoListUtils.getSetting(this.settings, 'style', '1'),
                newTab: LogoListUtils.getSetting(this.settings, 'newtab', 'F'),
                textColor: LogoListUtils.getSetting(this.settings, 'textcolor', '1'),
                logos: [],
                isEmpty: null,
                isCarousel: null,
                isGrid: null,
            };
            for (var i = 1; i <= this.MAX_LOGO_COUNT; i++) {
                var logo = LogoListUtils.getSettings(this.settings, [{ name: 'image', fieldName: 'image_url' }, 'link', 'alt', 'label'], i + "_");
                if (logo.image) {
                    logo.hasLink = !!logo.link;
                    this.logoList.logos.push(logo);
                }
            }
            this.logoList.isEmpty =
                !this.logoList.header && this.logoList.logos.length == 0;
            this.logoList.isCarousel =
                this.logoList.style == 2 &&
                    !Utils_1.Utils.oldIE() &&
                    this.logoList.logos.length > 0;
            this.logoList.isGrid = !this.logoList.isCarousel;
        };
        LogoListCCTView.prototype.getLogoCountPerLine = function () {
            var cnt = this.logoList.cntDesktop;
            if (Utils_1.Utils.isTabletDevice()) {
                cnt = this.logoList.cntTablet;
            }
            else if (Utils_1.Utils.isPhoneDevice()) {
                cnt = this.logoList.cntPhone;
            }
            return cnt;
        };
        LogoListCCTView.prototype.initSlider = function () {
            var _this = this;
            if (this.logoList.isCarousel) {
                setTimeout(function () {
                    _this._createSlider();
                }, 10);
            }
        };
        LogoListCCTView.prototype._createSlider = function () {
            var _this = this;
            var logoCount = this.getLogoCountPerLine();
            var renderSlider = logoCount < this.logoList.logos.length;
            var showControls = !!(renderSlider && Utils_1.Utils.isDesktopDevice());
            var wrapper = this.$('.' + this.WRAPPER_CLASS);
            if (showControls) {
                wrapper.removeClass(this.GRID_MARGIN_WRAPPER_CLASS);
                if (!wrapper.hasClass(this.CAROUSEL_CONTROLS_WRAPPER_CLASS)) {
                    wrapper.addClass(this.CAROUSEL_CONTROLS_WRAPPER_CLASS);
                }
            }
            else {
                wrapper.removeClass(this.CAROUSEL_CONTROLS_WRAPPER_CLASS);
                if (logoCount <= this.logoList.logos.length &&
                    !wrapper.hasClass(this.GRID_MARGIN_WRAPPER_CLASS)) {
                    wrapper.addClass(this.GRID_MARGIN_WRAPPER_CLASS);
                }
            }
            if (renderSlider) {
                if (!this.currentSlide) {
                    this.currentSlide = 0;
                }
                var sliderSettings = {
                    moveSlides: 1,
                    maxSlides: logoCount,
                    minSlides: 1,
                    slideWidth: this.$('.' + this.CAROUSEL_CONTAINER_CLASS).width() / logoCount,
                    infiniteLoop: true,
                    slideMargin: 0,
                    hideControlOnEnd: true,
                    responsive: true,
                    pager: true,
                    nextText: '<a class="logolistcct-next-icon"></a>',
                    prevText: '<a class="logolistcct-prev-icon"></a>',
                    controls: showControls,
                    wrapperClass: this.BXSLIDER_WRAPPER_CLASS,
                    startSlide: this.currentSlide,
                    onSlideAfter: function () {
                        _this.currentSlide = _this.sliderContainer
                            ? _this.sliderContainer.getCurrentSlide()
                            : 0;
                    },
                    onSliderResize: function () {
                        _this.resizeSlider();
                    },
                };
                if (!this.$('.' + this.BXSLIDER_WRAPPER_CLASS).length) {
                    this.sliderContainer = this.$('.' + this.CAROUSEL_CONTAINER_CLASS).bxSliderNew(sliderSettings);
                }
            }
        };
        LogoListCCTView.prototype.resizeSlider = function () {
            var newWidth = $(window).width();
            if (Math.abs(newWidth - this.windowWidth) > this.RESIZE_RERENDER_THRESHOLD) {
                this.windowWidth = newWidth;
                var newType = Utils_1.Utils.getDeviceType(newWidth);
                var oldType = Utils_1.Utils.getDeviceType(this.windowWidth);
                if (this.logoList.isCarousel && newType == oldType) {
                    if (this.sliderContainer) {
                        this.sliderContainer.destroySlider();
                        this.sliderContainer = null;
                        this._createSlider();
                    }
                }
            }
        };
        Object.defineProperty(LogoListCCTView.prototype, "childViews", {
            get: function () {
                var _this = this;
                return {
                    'NetSuite.LogoList.LogoListCCT.Logo.View': function () {
                        return new BackboneCollectionView({
                            childView: LogoListCCT_Logo_View_1.LogoView,
                            collection: new Backbone.Collection(_this.logoList.logos),
                            childViewOptions: {
                                target: _this.logoList.newTab == 'T' ? '_blank' : '_self',
                            },
                        });
                    },
                };
            },
            enumerable: true,
            configurable: true
        });
        LogoListCCTView.prototype.getContext = function () {
            return {
                hasHeader: !!this.logoList.header,
                header: this.logoList.header,
                cntDesktop: this.logoList.cntDesktop,
                cntTablet: this.logoList.cntTablet,
                cntPhone: this.logoList.cntPhone,
                isEmpty: this.logoList.isEmpty,
                type: this.logoList.isGrid ? 'grid' : 'carousel',
                wrapperClass: this.logoList.isGrid ? this.GRID_MARGIN_WRAPPER_CLASS : '',
                textColorClass: this.TEXT_COLOR_CLASS[+this.logoList.textColor],
            };
        };
        LogoListCCTView.prototype.logLinkClick = function (event) {
            var _this = this;
            // Prevents double logs apparently caused by bxSlider
            if (this.preventLinkClickLog) {
                return;
            }
            this.preventLinkClickLog = true;
            setTimeout(function () {
                _this.preventLinkClickLog = false;
            }, 100);
            Instrumentation_Helper_1.InstrumentationHelper.log('Link clicked');
        };
        LogoListCCTView.prototype.logInformation = function () {
            this.logLayout();
            this.logQuantityOfLogos();
        };
        LogoListCCTView.prototype.logLayout = function () {
            var layout;
            if (this.logoList.isCarousel) {
                layout = 'Carousel';
            }
            else {
                layout = 'Grid';
            }
            Instrumentation_Helper_1.InstrumentationHelper.log('Layout', layout);
        };
        LogoListCCTView.prototype.logQuantityOfLogos = function () {
            Instrumentation_Helper_1.InstrumentationHelper.log('Quantity of logos', "" + this.logoList.logos.length);
        };
        return LogoListCCTView;
    }(CustomContentTypeBaseView));
    exports.LogoListCCTView = LogoListCCTView;
});
